import React, { forwardRef, useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default function FilterPill({ label, active, options, showSearch, searchPlaceholder, onSelect }) {
  const [search, setSearch] = useState('')

  const filteredOptions = options.filter((option) => option.label.toLowerCase().includes(search.trim().toLowerCase()))

  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => (
        <div className="relative" ref={ref}>
          <button
            type="button"
            onClick={handleClick}
            className="flex items-center gap-2 bg-background rounded-full h-10 px-4 text-sm font-medium text-dark-blue whitespace-nowrap"
          >
            {active?.label ?? label}
            {open ? <UIcons.UilAngleUp size={16} className="text-secondary" /> : <UIcons.UilAngleDown size={16} className="text-secondary" />}
          </button>

          {
            open && (
              <div className="absolute left-0 top-11 z-20 w-56 bg-white border border-border-lines rounded-xl shadow-lg py-2">
                {
                  showSearch && (
                    <div className="relative px-3 pb-2">
                      <input
                        type="text"
                        autoFocus
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                        className="w-full bg-background rounded-lg pl-8 pr-2 py-1.5 text-sm outline-none"
                        placeholder={searchPlaceholder}
                      />
                      <UIcons.UilSearch className="text-placeholder absolute top-1/2 -translate-y-1/2 left-5" size={14} />
                    </div>
                  )
                }

                <ul className="max-h-60 overflow-y-auto">
                  {
                    filteredOptions.map((option) => (
                      <li key={option.value ?? 'all'}>
                        <button
                          type="button"
                          onClick={() => { onSelect(option); handleClick() }}
                          className="w-full text-left px-4 py-2 text-sm text-dark-blue hover:bg-background"
                        >
                          {option.label}
                        </button>
                      </li>
                    ))
                  }
                </ul>
              </div>
            )
          }
        </div>
      ))}
    />
  )
}
